import { Box, Flex, Input, Spacer, Text } from "@chakra-ui/react";
import { Card, Space, Spin, Table } from "antd";
import { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import styles from "./Bookingmastertable.module.scss";
import { set } from "lodash";

const BookingMasterTable: React.FC = () => {
  const [bookingData, setBookingData]: any = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isRestaurantDropdownOpen, setIsRestaurantDropdownOpen] =
    useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] =
    useState("All Restaurants");

  const [selectedStatus, setSelectedStatus] = useState("All");

  const [loading, setloading] = useState(true);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const data = useMemo(
    () =>
      bookingData.map((item: any) => ({
        key: item._id,
        bookingID: item._id,
        userName: item?.user?.firstName || "Not Available",
        restaurantName: item.restaurant.name,
        dateTime: `${item?.bookingDate || "-"} & ${
          item?.selectedSlot?.time || "-"
        }`,
        noOfGuest: item.noOfPeople,
        specialRequest: item.specialRequest || "-",
        bookingStatus: item.status,
      })),
    [bookingData]
  );

  const uniqueRestaurants = useMemo(() => {
    const restaurants = bookingData.map((item: any) => item.restaurant.name);
    return ["All Restaurants", ...new Set(restaurants)];
  }, [bookingData]);

  const filteredData = useMemo(() => {
    return data.filter((item: any) => {
      const matchesSearch = item.userName
        .toLowerCase()
        .includes(searchText.toLowerCase());
      const matchesRestaurant =
        selectedRestaurant === "All Restaurants" ||
        item.restaurantName === selectedRestaurant;
      const matchesStatus =
        selectedStatus === "All" ||
        item.bookingStatus.toLowerCase() === selectedStatus.toLowerCase();
      return matchesSearch && matchesRestaurant && matchesStatus;
    });
  }, [data, searchText, selectedRestaurant, selectedStatus]);

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Restaurant",
      dataIndex: "restaurantName",
      width: 150,
    },
    {
      title: "Date & Time",
      dataIndex: "dateTime",
      width: 150,
    },
    {
      title: "username",
      dataIndex: "userName",
      width: 150,
    },
    {
      title: "No. of Guests",
      dataIndex: "noOfGuest",
      width: 130,
    },
    {
      title: "Booking ID",
      dataIndex: "bookingID",
      width: 100,
    },
    {
      title: "Special Request",
      dataIndex: "specialRequest",
      width: 130,
    },
    // {
    //   title: "Special request",
    //   dataIndex: "specialRequest",
    //   width: 130,
    // },
    // {
    //   title: "Payment mode",
    //   dataIndex: "paymentMode",
    //   width: 130,
    // },
    {
      title: "Booking status",
      dataIndex: "bookingStatus",
      width: 130,

      render: (status: any) => {
        let bgColor = "";
        let textColor = "";

        switch (status.toLowerCase()) {
          case "booked":
            bgColor = "rgba(2, 164, 50, 0.10)";
            textColor = "#02A432";
            break;
          case "pending":
            bgColor = "rgba(255, 174, 0, 0.10)";
            textColor = "#FFAE00";
            break;
          case "cancelled":
            bgColor = "rgba(212, 47, 47, 0.10)";
            textColor = "#D42F2F";
            break;
          default:
            bgColor = "transparent";
            textColor = "inherit";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
            {/* {status} */}
          </span>
        );
      },
    },
    // {
    //   title: "User Status",
    //   dataIndex: "userStatus",
    //   width: 130,
    //   render: (status: any) => {
    //     let bgColor = "";
    //     let textColor = "";

    //     switch (status.toLowerCase()) {
    //       case "active":
    //         bgColor = "rgba(2, 164, 50, 0.10)";
    //         textColor = "#02A432";
    //         break;
    //       case "cancelled":
    //         bgColor = "rgba(212, 47, 47, 0.10)";
    //         textColor = "#D42F2F";
    //         break;
    //       case "-":
    //         bgColor = "transparent";
    //         textColor = "inherit";
    //         break;
    //       default:
    //         bgColor = "transparent";
    //         textColor = "inherit";
    //     }

    //     return (
    //       <span
    //         style={{
    //           backgroundColor: bgColor,
    //           color: textColor,
    //           padding: "6px 10px",
    //           borderRadius: "6px",
    //           fontSize: "14px",
    //           display: "inline-block",
    //         }}
    //       >
    //         {status}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   title: "Cancellation Refund",
    //   dataIndex: "CancellationRefund",
    //   width: 150,
    // },
  ];

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const formatDate = (date: Date | null): string => {
    if (!date) return "Today"; // Handles null case
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [startDate, setStartDate] = useState<string>(() => {
    const today = new Date();
    return formatDate(today);
  });

  useEffect(() => {
    if (!startDate) {
      return;
    }
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/booking?bookingDate=${startDate}`
        );

        setBookingData(response.data.data);
        setloading(false);
      } catch (err) {
        console.log("error is", err);
        setloading(false);
      }
    };

    fetchData();
  }, [startDate]);

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e) => setSearchText(e.target.value)}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none", // Add this line to remove the blue outline
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none", // Add this line to ensure outline is removed in all browsers
                }}
              />
            </Box>
            <Spacer />
            <Flex gap="8px">
              <div style={{ position: "relative" }}>
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px;"
                  display="flex"
                  gap="10px"
                  cursor="pointer"
                  onClick={() => {
                    setIsRestaurantDropdownOpen(!isRestaurantDropdownOpen);
                    setIsStatusDropdownOpen(false);
                  }}
                >
                  <Text color="#424242" fontSize="14px">
                    {selectedRestaurant || "Restaurant name"}
                  </Text>

                  <img
                    src="/icons/dropdownarrow.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>

                {isRestaurantDropdownOpen && (
                  <div className={styles.dropdownPopup}>
                    <div className={styles.categoriesList}>
                      {uniqueRestaurants.map((restaurant: any) => (
                        <div
                          key={restaurant}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                          onClick={() => {
                            setSelectedRestaurant(restaurant);
                            setIsRestaurantDropdownOpen(false);
                          }}
                        >
                          <Text
                            color="#424242"
                            fontSize="14px"
                            className={`${styles.category} ${
                              selectedRestaurant === restaurant
                                ? styles.selectedCategory
                                : ""
                            }`}
                          >
                            {restaurant}
                          </Text>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div style={{ position: "relative" }}>
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px;"
                  display="flex"
                  gap="10px"
                  cursor="pointer"
                  onClick={() => {
                    setIsStatusDropdownOpen(!isStatusDropdownOpen);
                    setIsRestaurantDropdownOpen(false);
                  }}
                >
                  <Text color="#424242" fontSize="14px">
                    {selectedStatus}
                  </Text>

                  <img
                    src="/icons/dropdownarrow.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>

                {isStatusDropdownOpen && (
                  <div className={styles.dropdownPopup}>
                    <div className={styles.categoriesList}>
                      {["All", "Booked", "Pending", "Cancelled"].map(
                        (status) => (
                          <div
                            key={status}
                            onClick={() => {
                              setSelectedStatus(status);
                              setIsStatusDropdownOpen(false);
                            }}
                          >
                            <Text
                              className={`${styles.category} ${
                                selectedStatus === status
                                  ? styles.selectedCategory
                                  : ""
                              }`}
                              color="#424242"
                              fontSize="14px"
                            >
                              {status}
                            </Text>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              <Box position="relative">
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px"
                  display="flex"
                  gap="10px"
                  alignItems="center"
                  cursor="pointer"
                  onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
                >
                  <Text color="#424242" fontSize="14px">
                    {startDate}
                  </Text>

                  <img
                    src="/icons/calenderlogo.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>

                {isDatePickerOpen && (
                  <Box className={styles.datepickerDiv}>
                    <DatePicker
                      selected={new Date(startDate)}
                      onChange={(date: Date | null) => {
                        if (date) {
                          setStartDate(formatDate(date));
                        }
                        setIsDatePickerOpen(false);
                      }}
                      // maxDate={new Date()}
                      inline
                    />
                  </Box>
                )}
              </Box>
            </Flex>
          </Flex>

          <Spacer></Spacer>

          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={loading}
          />
        </div>
      </div>
    </>
  );
};

export default BookingMasterTable;
